export const USER_TEXT = {
  PROFILE_INFO: 'user.profile_info',
  PROFILE: 'user.profile',
  RESET_PASSWORD: 'user.reset_password',
  SYSTEM_LANGUAGE: 'user.system_language',
}
